import { render, staticRenderFns } from "./EmpireRow.vue?vue&type=template&id=1bb2201c&scoped=true&"
import script from "./EmpireRow.vue?vue&type=script&lang=js&"
export * from "./EmpireRow.vue?vue&type=script&lang=js&"
import style0 from "./EmpireRow.vue?vue&type=style&index=0&id=1bb2201c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2201c",
  null
  
)

export default component.exports